import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../node_modules/classnames/index.js';

var CPagination = forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, align = _a.align, className = _a.className, size = _a.size, rest = __rest(_a, ["children", "align", "className", "size"]);
    return (React.createElement("nav", __assign({ ref: ref }, rest),
        React.createElement("ul", { className: classNames('pagination', (_b = {},
                _b["justify-content-".concat(align)] = align,
                _b["pagination-".concat(size)] = size,
                _b), className) }, children)));
});
CPagination.propTypes = {
    align: PropTypes.oneOf(['start', 'center', 'end']),
    children: PropTypes.node,
    className: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg']),
};
CPagination.displayName = 'CPagination';

export { CPagination };
//# sourceMappingURL=CPagination.js.map
